import React from 'react'
import { Card } from '@mui/material'
import { useIsMobile } from '@/hooks/use-mobile'
import {CardProps} from "@mui/material/Card/Card";

const MobileFriendlyCard = ({ children, ...props }: CardProps) => {
  const isMobile = useIsMobile()

  return (
    <Card elevation={0} square={isMobile} {...props} sx={{
        ...(isMobile ? {borderRadius: 0} : {}),
        display: 'flex',
        flex: 1,
        ...props.sx
      }}
    >
      {children}
    </Card>
  )
}

export default MobileFriendlyCard
